define('collections/nemoTargetValues',["T1NemoCollection", "collections/targetValues", "utils/ClassUtils"], function (T1NemoCollection, TargetValues, ClassUtils) {
  "use strict";

  var targetValuesPrototype = ClassUtils.cloneClass(TargetValues, 1, ["buildPostObjForContextualTargets", "searchConfiguration", "initialize"]);
  return T1NemoCollection.extend(targetValuesPrototype);
});
